import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import classNames from 'classnames';

import { connect } from 'react-redux';

import { mountCompose, moveReplyComposeToPanel, unmountCompose } from 'flavours/glitch/actions/compose';
import ServerBanner from 'flavours/glitch/components/server_banner';
import ComposeFormContainer from 'flavours/glitch/features/compose/containers/compose_form_container';
import SearchContainer from 'flavours/glitch/features/compose/containers/search_container';
import { identityContextPropShape, withIdentity } from 'flavours/glitch/identity_context';
import { isInlineReplyComposeActive } from 'flavours/glitch/utils/inline_reply';

import CurrentMammouth from './current_mammouth';

const SCREEN_MARGIN = 12;
const MAX_EXPANDED_WIDTH = 520;

const mapStateToProps = state => ({
  showInlineReplyPlaceholder: isInlineReplyComposeActive(state),
  expandedComposePanel: state.getIn(['local_settings', 'expanded_compose_panel']),
});

class ComposePanel extends PureComponent {
  static propTypes = {
    identity: identityContextPropShape,
    dispatch: PropTypes.func.isRequired,
    showInlineReplyPlaceholder: PropTypes.bool,
    expandedComposePanel: PropTypes.bool,
  };

  state = {
    expandedLayoutStyle: undefined,
  };

  panelRef = createRef();

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(mountCompose());
    this.observeLayout();
    window.addEventListener('resize', this.updateExpandedLayout);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.expandedComposePanel !== this.props.expandedComposePanel) {
      this.updateExpandedLayout();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(unmountCompose());
    window.removeEventListener('resize', this.updateExpandedLayout);
    this.resizeObserver?.disconnect();
  }

  observeLayout = () => {
    this.resizeObserver = new ResizeObserver(this.updateExpandedLayout);

    if (this.panelRef.current) {
      this.resizeObserver.observe(this.panelRef.current);
    }

    this.updateExpandedLayout();
  };

  setPanelRef = (node) => {
    this.panelRef.current = node;

    if (node && this.resizeObserver) {
      this.resizeObserver.observe(node);
      this.updateExpandedLayout();
    }
  };

  updateExpandedLayout = () => {
    const { expandedComposePanel } = this.props;
    const panel = this.panelRef.current;

    if (!expandedComposePanel || !panel) {
      if (this.state.expandedLayoutStyle) {
        this.setState({ expandedLayoutStyle: undefined });
      }
      return;
    }

    const panelRect = panel.getBoundingClientRect();
    const maxExtraWidth = Math.max(0, panelRect.left - SCREEN_MARGIN);
    const targetWidth = Math.min(
      MAX_EXPANDED_WIDTH,
      Math.max(285, panelRect.right - SCREEN_MARGIN),
    );
    const extraWidth = Math.min(targetWidth - 285, maxExtraWidth);
    const expandedWidth = 285 + extraWidth;

    this.setState({
      expandedLayoutStyle: {
        '--compose-expanded-width': `${expandedWidth}px`,
        '--compose-expanded-shift': `${-extraWidth}px`,
      },
    });
  };

  handleRestoreCompose = () => {
    this.props.dispatch(moveReplyComposeToPanel());
  };

  render() {
    const { signedIn } = this.props.identity;
    const { showInlineReplyPlaceholder, expandedComposePanel } = this.props;
    const { expandedLayoutStyle } = this.state;

    return (
      <div
        ref={this.setPanelRef}
        className={classNames('compose-panel', { 'compose-panel--expanded': expandedComposePanel })}
        style={expandedLayoutStyle}
      >
        <SearchContainer openInRoute />

        {!signedIn && (
          <>
            <ServerBanner />
            <div className='flex-spacer' />
          </>
        )}

        <div className='compose-panel__compose-area'>
          {signedIn && showInlineReplyPlaceholder && (
            <button
              type='button'
              className='compose-panel__reply-placeholder'
              onClick={this.handleRestoreCompose}
              title='Reprendre la réponse ici'
              aria-label='Reprendre la réponse dans le panneau de composition'
            >
              ✏️
            </button>
          )}

          {signedIn && !showInlineReplyPlaceholder && (
            <ComposeFormContainer singleColumn />
          )}
        </div>

        <div className='compose-panel__mammouth'>
          <CurrentMammouth />
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps)(withIdentity(ComposePanel));
